"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdLaravelReport = require("cccisd-laravel-report");
var _Content = _interopRequireDefault(require("../Content"));
var _populateMetric = _interopRequireDefault(require("../populateMetric.js"));
var _utils = require("../Settings/utils.js");
var _config = require("../config.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var VizReport = function VizReport(props) {
  var metrics = props.metrics,
    vizData = props.vizData,
    deployments = props.deployments,
    settings = props.settings,
    overrideInitialVisualizeSettings = props.overrideInitialVisualizeSettings;
  var filteredMetrics = (0, _react.useMemo)(function () {
    return metrics.slice(0, _config.REPORT_METRICS_LIMIT);
  }, [metrics]);
  var _useMemo = (0, _react.useMemo)(function () {
      var totalMetrics = filteredMetrics.length;
      var loadedMetrics = filteredMetrics.filter(function (item) {
        return item.variableId in vizData;
      }).length;
      return [loadedMetrics === totalMetrics, Math.floor(loadedMetrics / totalMetrics * 100)];
    }, [filteredMetrics, vizData]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    allVizDataLoaded = _useMemo2[0],
    vizLoadedPercent = _useMemo2[1];
  var metricsMatch = (0, _react.useMemo)(function () {
    if (!allVizDataLoaded) {
      return {};
    }
    return filteredMetrics.reduce(function (obj, item) {
      obj[item.reportHeader] = item;
      return obj;
    }, {});
  }, [allVizDataLoaded, filteredMetrics]);
  var getCrossMetric = function getCrossMetric(metricSettings) {
    if (!metricSettings.compareWith) {
      return null;
    }
    var reportHeader = metricSettings.compareWith.replace('variables.', '');
    return (0, _populateMetric["default"])(metricsMatch[reportHeader]);
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, !allVizDataLoaded ? /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
    loading: true,
    type: "inline",
    percentage: vizLoadedPercent
  }) : /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Report, null, filteredMetrics.map(function (metric) {
    var currentMetric = (0, _populateMetric["default"])(metric);
    var currentMetricSettings = (0, _utils.getActualMetricSettings)(currentMetric, settings[currentMetric.variableId], overrideInitialVisualizeSettings);
    return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, {
      key: metric.variableId
    }, /*#__PURE__*/_react["default"].createElement(_Content["default"], {
      currentMetric: currentMetric,
      currentMetricSettings: currentMetricSettings,
      deployments: deployments,
      currentCrossMetric: getCrossMetric(currentMetricSettings),
      data: vizData[currentMetric.variableId]
    }));
  })));
};
VizReport.propTypes = {
  metrics: _propTypes["default"].array,
  vizData: _propTypes["default"].object,
  deployments: _propTypes["default"].array,
  settings: _propTypes["default"].object,
  overrideInitialVisualizeSettings: _propTypes["default"].object
};
var _default = exports["default"] = VizReport;